import { useEffect, useState } from "react";
import { CalendarCheck, Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { NavLinks, buildWhatsAppUrl } from "@/data/SiteContent";

export default function Header() {
  const [IsScrolled, setIsScrolled] = useState(false);
  const [IsMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const AppointmentUrl = buildWhatsAppUrl();

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        IsScrolled || IsMenuOpen
          ? "border-b border-gold/20 bg-ink/95 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-8 lg:px-16">
        <a href="#inicio" aria-label="Ir al inicio">
          <Logo />
        </a>

        <nav aria-label="Navegación principal" className="hidden items-center gap-7 lg:flex">
          {NavLinks.map((pLink) => (
            <a
              key={pLink.Id}
              href={pLink.Href}
              data-testid={`nav-link-${pLink.Id}`}
              className="text-sm text-white/80 transition-colors duration-300 hover:text-gold"
            >
              {pLink.Label}
            </a>
          ))}
          <a
            href={AppointmentUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-appointment-button"
            className="flex items-center gap-2 border border-gold bg-gold px-5 py-2.5 text-sm font-medium text-ink transition-colors duration-300 hover:bg-transparent hover:text-gold"
          >
            <CalendarCheck className="h-4 w-4" aria-hidden="true" />
            Agendar una cita
          </a>
        </nav>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-expanded={IsMenuOpen}
          aria-label={IsMenuOpen ? "Cerrar menú" : "Abrir menú"}
          onClick={() => setIsMenuOpen(!IsMenuOpen)}
          className="text-white lg:hidden"
        >
          {IsMenuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {IsMenuOpen && (
        <nav
          aria-label="Navegación móvil"
          data-testid="mobile-menu"
          className="border-t border-gold/20 bg-ink px-4 pb-8 pt-4 lg:hidden"
        >
          <ul className="flex flex-col gap-1">
            {NavLinks.map((pLink) => (
              <li key={pLink.Id}>
                <a
                  href={pLink.Href}
                  data-testid={`mobile-nav-link-${pLink.Id}`}
                  onClick={() => setIsMenuOpen(false)}
                  className="block py-3 font-serif text-lg text-white/85 transition-colors duration-300 hover:text-gold"
                >
                  {pLink.Label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href={AppointmentUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-appointment-button"
            className="mt-4 flex items-center justify-center gap-2 bg-gold px-5 py-3 text-sm font-medium text-ink"
          >
            <CalendarCheck className="h-4 w-4" aria-hidden="true" />
            Agendar una cita
          </a>
        </nav>
      )}
    </header>
  );
}
